<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,9C15.55,9,16,8.55,16,8C16,7.45,15.55,7,15,7C15,7,14,7,14,7C14,7,14,4,14,4C14,4,15,4,15,4C15.55,4,16,3.55,16,3C16,2.45,15.55,2,15,2C15,2,14,2,14,2C14,2,14,1,14,1C14,0.45,13.55,0,13,0C12.45,0,12,0.45,12,1C12,1,12,2,12,2C12,2,9,2,9,2C9,2,9,1,9,1C9,0.45,8.55,0,8,0C7.45,0,7,0.45,7,1C7,1,7,2,7,2C7,2,4,2,4,2C4,2,4,1,4,1C4,0.45,3.55,0,3,0C2.45,0,2,0.45,2,1C2,1,2,2,2,2C2,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3.55,0.45,4,1,4C1,4,2,4,2,4C2,4,2,7,2,7C2,7,1,7,1,7C0.45,7,0,7.45,0,8C0,8.55,0.45,9,1,9C1,9,2,9,2,9C2,9,2,12,2,12C2,12,1,12,1,12C0.45,12,0,12.45,0,13C0,13.55,0.45,14,1,14C1,14,2,14,2,14C2,14,2,15,2,15C2,15.55,2.45,16,3,16C3.55,16,4,15.55,4,15C4,15,4,14,4,14C4,14,7,14,7,14C7,14,7,15,7,15C7,15.55,7.45,16,8,16C8.55,16,9,15.55,9,15C9,15,9,14,9,14C9,14,12,14,12,14C12,14,12,15,12,15C12,15.55,12.45,16,13,16C13.55,16,14,15.55,14,15C14,15,14,14,14,14C14,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,14,12,14,12C14,12,14,9,14,9C14,9,15,9,15,9C15,9,15,9,15,9ZM7,12C7,12,4,12,4,12C4,12,4,9,4,9C4,9,7,9,7,9C7,9,7,12,7,12C7,12,7,12,7,12ZM7,7C7,7,4,7,4,7C4,7,4,4,4,4C4,4,7,4,7,4C7,4,7,7,7,7C7,7,7,7,7,7ZM12,12C12,12,9,12,9,12C9,12,9,9,9,9C9,9,12,9,12,9C12,9,12,12,12,12C12,12,12,12,12,12ZM12,7C12,7,9,7,9,7C9,7,9,4,9,4C9,4,12,4,12,4C12,4,12,7,12,7C12,7,12,7,12,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Grid',
} as DefineComponent
</script>
